import { instance, requests } from "../config"
import { I2faLoginRequiredResponse, I2faSetupResponse, IAuthDataModel, IAuthResponse, IRegistrationPostData } from "./models/authDataModel"
import { IInvitationPostData, IInvitationPostResponse } from "./models/invitation";
import { IChangePasswordData } from "./models/recovery";

export const Auth = {
    login: async (data: IAuthDataModel): Promise<IAuthResponse | I2faLoginRequiredResponse> => {
        try {
            let res = await requests.post('auth', 'go', data)
            if (res.requires2fa) {
                return res as I2faLoginRequiredResponse
            }
            localStorage.setItem('user', JSON.stringify(res.token));
            instance.updateToken = res.token
            return res as IAuthResponse
        } catch (err) {
            throw err
        } 
    },
    verify2fa: async (tempToken: string, code: string): Promise<IAuthResponse> => {
        try {
            let res = await requests.post('auth/2fa/verify', 'go', { tempToken, code })
            localStorage.setItem('user', JSON.stringify(res.token))
            instance.updateToken = res.token
            return res as IAuthResponse
        } catch (err) {
            throw err
        }
    },
    loadUser: async (token?:string) => {
        if (token) {
            instance.updateToken = token
        }
        try {
            let res = await requests.get('auth', 'node')
            return res
        } catch (err) {
            throw err
        }
    },
    getDataBases: (data: string) => requests.get('auth/database', 'node'),
    patchDataBase: (data: {dbId: string}) => requests.patch('auth', 'node', data),
    getCompanies: (data: string) => requests.get('auth/company', 'node'),
    patchDataBaseGo: (companyId : number | string, companyInternal: number | string) => 
        requests.get(`auth/change_company?CompanyId=${companyId}&CompanyInternal=${companyInternal}`, 'go'),
    getInternalCompanies: (id: number | string) => requests.get(`auth/companies_internal?CompanyId=${id}`, 'go'),
    updateCompany: (data: {
        year: string,
        company_internal: string
    }) => requests.put('auth', 'node', data),
    sendSMS: (phone: string) => requests.get(`auth/send_sms?Phone=${phone}`, 'go'),
    sendRecoveryCode: (phone: string, login: string) => requests.get(`auth/send_recovery_code?Phone=${phone}&UserID=${login}`, 'go'),
    verifySMS: (codeSMS: string, phone: string) => requests.get(`auth/check_code?Phone=${phone}&Code=${codeSMS}`, 'go'),
    checkRecoveryCode: (codeSMS: string, phone: string, login: string) => requests.get(`auth/check_recovery_code?Phone=${phone}&Code=${codeSMS}&UserID=${login}`, 'go'),
    changePassword: (data: IChangePasswordData) => requests.put('/auth/change_password_by_code', 'go', data),
    checkUserName: (userName: string) => requests.get(`auth/check_user?Username=${userName}`, 'go'),
    getInviteLink: (data: IInvitationPostData): Promise<IInvitationPostResponse> => requests.post(`/auth/invitation`, "go", data),
    registration: (data: IRegistrationPostData) => requests.post('/auth/register', 'go', data),
    setup2fa: (): Promise<I2faSetupResponse> => requests.post('auth/2fa/setup', 'go', {}),
    enable2fa: (code: string) => requests.post('auth/2fa/enable', 'go', { code }),
    disable2fa: () => requests.delete('auth/2fa/disable', 'go'),
}